import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from 'react';
import clsx from 'clsx';
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
import { useCropImageModal } from '../../CropImageModal';
import { T } from '../../i18n';
export const VariantAvatar = (props) => {
    var _a;
    const { onChange, image, className, cropable = false, shape = 'round', } = props;
    const fileInputRef = useRef();
    const { onSelectFile, children: cropModal } = useCropImageModal({
        onSuccess: ({ croppedImage }) => onChange === null || onChange === void 0 ? void 0 : onChange(croppedImage),
        options: {
            shape,
        },
    });
    const onChangeFile = (e) => {
        var _a;
        const file = (_a = Array.from(e.target.files)) === null || _a === void 0 ? void 0 : _a[0];
        // allow to select same file twice
        e.target.value = '';
        onSelectFile(file);
        if (!cropable) {
            onChange === null || onChange === void 0 ? void 0 : onChange(file);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: clsx('hover:bg-surface-hovered rounded-full relative w-32 h-32', className), children: [_jsx(Avatar, { size: "3xl", src: ((_a = image === null || image === void 0 ? void 0 : image.urls) === null || _a === void 0 ? void 0 : _a.small) || (image === null || image === void 0 ? void 0 : image.url), rounded: shape === 'rect' ? 'none' : 'full' }, void 0), _jsx("input", { type: "file", className: "hidden", multiple: false, ref: fileInputRef, onChange: onChangeFile }, void 0), (image === null || image === void 0 ? void 0 : image.isLoading) && (_jsx("div", { className: clsx('flex items-center justify-center text-white bg-background-backdrop absolute top-0 bottom-0 start-0 end-0', shape === 'round' && 'rounded-full'), children: _jsx(SpinnerIcon, { className: "animate-spin h-7 w-7" }, void 0) }, void 0)), !(image === null || image === void 0 ? void 0 : image.isLoading) && (_jsx("div", { onClick: () => {
                            fileInputRef.current.click();
                        }, className: clsx('flex items-center justify-center text-white bg-black bg-opacity-50 opacity-0 hover:opacity-100 absolute top-0 bottom-0 start-0 end-0 cursor-pointer', shape === 'round' && 'rounded-full'), children: _jsx(T, { id: "Generics.Change.Verb", defaultMessage: "Change" }, void 0) }, void 0))] }, void 0), cropable && cropModal] }, void 0));
};
//# sourceMappingURL=VariantAvatar.js.map